import { EVENT_ACTIONS } from '../../../constants/yandexMetric';
import AlfaImg from './images/alfa-icon.svg';
import EsiaImg from './images/esia-icon.svg';
import SberImg from './images/sber-icon.svg';
import SovcomImg from './images/sovcom-id.svg';
import TbankImg from './images/tbank-icon.svg';
import VkImg from './images/vk-icon.svg';
import VtbImg from './images/vtb-id.svg';
import YandexImg from './images/yandex-icon.svg';
import { SocialProvidersType } from './types';

type SocialButtonProps = {
	label: string;
	icon: string;
	ymEventAction: string;
	isOther?: boolean;
	isHiddenIOS?: boolean;
	isHiddenMobilePlatform?: boolean;
};

export const SOCIAL_BUTTON_PROPS: Record<SocialProvidersType, SocialButtonProps> = {
	yandex: {
		label: 'Яндекс ID',
		icon: YandexImg,
		isOther: true,
		isHiddenMobilePlatform: true,
		ymEventAction: EVENT_ACTIONS.CLICK_YANDEX_ID_AUTH_POPUP,
	},
	tbank: {
		label: 'T-ID',
		icon: TbankImg,
		isHiddenIOS: true,
		isHiddenMobilePlatform: true,
		ymEventAction: EVENT_ACTIONS.CLICK_TINKOFF_ID_AUTH_POPUP,
	},
	alfa: {
		label: 'Альфа ID',
		icon: AlfaImg,
		isHiddenIOS: true,
		isHiddenMobilePlatform: true,
		ymEventAction: EVENT_ACTIONS.CLICK_ALFA_ID_AUTH_POPUP,
	},
	sber: {
		label: 'Сбер ID',
		icon: SberImg,
		isHiddenIOS: true,
		isHiddenMobilePlatform: true,
		ymEventAction: EVENT_ACTIONS.CLICK_SBER_ID_AUTH_POPUP,
	},
	vk: {
		label: 'VK ID',
		icon: VkImg,
		isOther: true,
		isHiddenMobilePlatform: true,
		ymEventAction: EVENT_ACTIONS.CLICK_VK_ID_AUTH_POPUP,
	},
	esia: {
		label: 'Госуслуги',
		icon: EsiaImg,
		isHiddenIOS: false,
		isHiddenMobilePlatform: false,
		ymEventAction: EVENT_ACTIONS.CLICK_ESIA_ID_AUTH_POPUP,
	},
	vtb: {
		label: 'ВТБ ID',
		icon: VtbImg,
		isHiddenIOS: true,
		isHiddenMobilePlatform: true,
		ymEventAction: EVENT_ACTIONS.CLICK_VTB_ID_AUTH_POPUP,
	},
	sovcom: {
		label: 'Совкомбанк ID',
		icon: SovcomImg,
		isHiddenIOS: true,
		isHiddenMobilePlatform: true,
		ymEventAction: EVENT_ACTIONS.CLICK_SOVCOM_ID_AUTH_POPUP,
	},
};

export const SOCIAL_PROVIDERS = {
	yandex: 'yandex',
	tbank: 'tbank',
	alfa: 'alfa',
	sber: 'sber',
	esia: 'esia',
	vk: 'vk',
	sovcom: 'sovcom',
	vtb: 'vtb',
} as const;
